import { Form, Spin } from "antd";
import { useCallingIncentives } from "./store";
import RenderFilterFields from "./RenderFilterFields";
import moment from "moment";

const CallingIncentiveFilter = ({
  onClose,
  onApplyFilters,
  setCurrentPage,
  setPageSize,
  setFilterQueryParams,
  buildQueryString,
  filterAndTransformParams,
}) => {
  const {
    callingIncentivesFilterData,
    callingIncentivesFilterDataLoading,
    fetchCallingIncentivesFilters,
    fetchCallingIncentivesData,
  } = useCallingIncentives();

  const [form] = Form.useForm();

  const handleFieldChange = (fieldCode, value) => {
    form.setFieldsValue({ [fieldCode]: value });
  };

  const handleFinish = (values) => {
    onApplyFilters(values);
    onClose();
  };
  const getStartOfMonth = () => {
    return moment().startOf("month").format("YYYY-MM-DD");
  };

  const handleClear = () => {
    form.resetFields();
    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
      empType: "HAIR_COACH",
      incentiveMonthDate: getStartOfMonth(),
    };
    const updatedFilters = filterAndTransformParams(initialQueryParam);
    const queryString = buildQueryString(updatedFilters);
    fetchCallingIncentivesData(queryString);
    setCurrentPage(1);
    setPageSize(10);
    onClose();
  };

  return (
    <Spin spinning={callingIncentivesFilterDataLoading}>
      <Form layout="vertical" onFinish={handleFinish} form={form}>
        <RenderFilterFields
          filtersData={callingIncentivesFilterData.filters}
          onFieldChange={handleFieldChange}
          handleClear={handleClear}
          setFilterQueryParams={setFilterQueryParams}
        />
      </Form>
    </Spin>
  );
};
export default CallingIncentiveFilter;
